import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container } from '@mui/material';
// import SideBarNav from '../../../Layout/SideBarNav/SideBarNav';
import SideBarNav from '../../../../Layout/SideBarNav/SideBarNav';

// import AddBankBranchPage from './AddBankBranchPage';

import AddBankEmployeePage from './AddBankEmployeePage';

import UpdateBankEmployeePage from './UpdateBankEmployeePage';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AddUpdateBankEETabsPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>

        <SideBarNav/>
        <Container>

            <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Add Bank Branch Employee" {...a11yProps(0)} />
                <Tab label="Update Bank Branch Employee" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {/* Item One */}
                <AddBankEmployeePage/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <UpdateBankEmployeePage/>
            </CustomTabPanel>
            </Box>
        </Container>
    
    </>
  );
}